/* dhp-slider.js - Optimized Custom Hero Banner Slider Script */

(function () {
  'use strict';

  function initSlider(container) {
    if (!container || container.dataset.initialized) return;
    container.dataset.initialized = 'true';

    let slides = container.querySelectorAll('.dhp-slide');
    const dots = container.querySelectorAll('.dhp-slider__dot');
    const totalSlides = dots.length > 0 ? dots.length : slides.length;

    let currentIndex = 0;
    let autoplayTimer = null;
    const isAutoplay = container.dataset.autoplay === 'true';
    const speed = parseInt(container.dataset.speed, 10) || 5000;

    // Loader for subsequent slides stored in <template>
    const loadRemainingSlides = () => {
      if (container.dataset.slidesLoaded) return;
      container.dataset.slidesLoaded = 'true';

      const template = container.querySelector('template[id^="dhp-slides-template-"]');
      if (template) {
        const clone = template.content.cloneNode(true);
        const controls = container.querySelector('.dhp-slider__controls');
        if (controls) {
          container.insertBefore(clone, controls);
        } else {
          container.appendChild(clone);
        }
        
        // Cache the newly updated slide list
        slides = container.querySelectorAll('.dhp-slide');
      }
    };

    const goToSlide = (index) => {
      if (!slides || slides.length === 0) return;

      // Force hydration if target slide is not the first one and slides aren't loaded yet
      if (index > 0 && !container.dataset.slidesLoaded) {
        loadRemainingSlides();
      }

      // If loaded dynamically, refresh cache if needed
      if (container.dataset.slidesLoaded && slides.length <= 1) {
        slides = container.querySelectorAll('.dhp-slide');
      }

      const len = slides.length;
      if (len === 0) return;

      const targetIndex = ((index % len) + len) % len;

      // Batch DOM writes to avoid layout thrashing
      for (let i = 0; i < len; i++) {
        const slide = slides[i];
        if (i === targetIndex) {
          slide.classList.add('is-active');
        } else {
          slide.classList.remove('is-active');
        }
      }

      const dotsLen = dots.length;
      for (let i = 0; i < dotsLen; i++) {
        const dot = dots[i];
        if (i === targetIndex) {
          dot.classList.add('is-active');
        } else {
          dot.classList.remove('is-active');
        }
      }

      currentIndex = targetIndex;
    };

    const nextSlide = () => {
      if (totalSlides <= 1) return;
      goToSlide((currentIndex + 1) % totalSlides);
    };

    const startAutoplay = () => {
      if (isAutoplay && totalSlides > 1) {
        stopAutoplay();
        autoplayTimer = setInterval(nextSlide, speed);
      }
    };

    const stopAutoplay = () => {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    };

    // Hydrate immediately on dot interactions
    if (dots.length > 1) {
      const handleDotClick = (dot, idx) => {
        dot.addEventListener('click', function () {
          loadRemainingSlides();
          goToSlide(idx);
          startAutoplay();
        }, { passive: true });
      };

      dots.forEach((dot, index) => {
        handleDotClick(dot, index);
      });
    }

    // Lazy Hydration: Hydrate slides only when visible or idle
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          loadRemainingSlides();
          startAutoplay();
        } else {
          stopAutoplay();
        }
      });
    }, { rootMargin: '200px' });
    
    observer.observe(container);

    // Idle trigger to load remaining slides in the background
    if (window.requestIdleCallback) {
      window.requestIdleCallback(() => loadRemainingSlides());
    } else {
      if (document.readyState === 'complete') {
        loadRemainingSlides();
      } else {
        window.addEventListener('load', () => loadRemainingSlides(), { once: true });
      }
    }

    // Shopify Theme Editor Integration
    const handleBlockSelect = (event) => {
      loadRemainingSlides();
      slides = container.querySelectorAll('.dhp-slide');
      
      const selectedIndex = Array.from(slides).findIndex((s) => s.dataset.blockId === event.detail.blockId);
      if (selectedIndex !== -1) {
        goToSlide(selectedIndex);
        stopAutoplay();
      }
    };

    const handleBlockDeselect = () => {
      startAutoplay();
    };

    container.addEventListener('shopify:block:select', handleBlockSelect);
    container.addEventListener('shopify:block:deselect', handleBlockDeselect);

    // Memory Leak Cleanup
    const cleanup = () => {
      stopAutoplay();
      observer.disconnect();
      container.removeEventListener('shopify:block:select', handleBlockSelect);
      container.removeEventListener('shopify:block:deselect', handleBlockDeselect);
      document.removeEventListener('shopify:section:unload', handleSectionUnload);
    };

    const handleSectionUnload = (e) => {
      if (e.detail.sectionId === container.dataset.sectionId) {
        cleanup();
      }
    };

    document.addEventListener('shopify:section:unload', handleSectionUnload);
  }

  function initAllSliders() {
    const sliders = document.querySelectorAll('.dhp-slider');
    const slidersLen = sliders.length;
    for (let i = 0; i < slidersLen; i++) {
      initSlider(sliders[i]);
    }
  }

  // Load handler
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSliders);
  } else {
    initAllSliders();
  }

  // Handle section load event in Shopify Editor
  document.addEventListener('shopify:section:load', function (e) {
    const container = document.querySelector(`.dhp-slider--${e.detail.sectionId}`);
    if (container) {
      initSlider(container);
    }
  });

})();
